module.exports = __webpack_public_path__ + "static/img/wxCodeGuide.159327f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxCodeGuide.png
// module id = aAXp
// module chunks = 1